import { actions } from './price_list/actions'
import { getters } from './price_list/getters'
import { state } from './price_list/state'
import { mutations } from './price_list/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
